export interface Movie {
  id: string;
  title: string;
  englishTitle: string;
  category: 'movie' | 'tv' | 'anime' | 'variety';
  year: number;
  rating: number;
  poster: string;
  backdrop: string;
  description: string;
  director: string;
  cast: string[];
  genres: string[];
  quality: string;
  duration: string;
  region: string;
  isHot: boolean;
  isNew: boolean;
  episodes?: number;
  synopsis?: string;
}

export const movies: Movie[] = [
  {
    id: 'movie-1',
    title: '流浪地球3',
    englishTitle: 'The Wandering Earth 3',
    category: 'movie',
    year: 2027,
    rating: 9.2,
    poster: 'https://readdy.ai/api/search-image?query=Sci-fi%20movie%20poster%20with%20astronauts%20and%20massive%20spaceship%20engines%20against%20a%20dark%20cosmic%20backdrop%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20epic%20scale%2C%20warm%20orange%20and%20deep%20space%20blue%20tones%2C%20movie%20poster%20style%20with%20Chinese%20text%20space&width=600&height=900&seq=movie-poster-1&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20landscape%20with%20massive%20planet%20engines%20burning%20in%20space%2C%20dramatic%20orange%20thrust%20flames%20against%20dark%20cosmos%2C%20cinematic%20widescreen%20composition%2C%20atmospheric%20lighting%2C%20grand%20scale%20visual%20effects&width=1600&height=700&seq=movie-bg-1&orientation=landscape',
    description: '太阳急速老化，持续膨胀，即将吞没整个太阳系。人类面临前所未有的生存危机，联合政府决定启动"流浪地球计划"的最终阶段，带着地球踏上2500年的星际之旅。',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    genres: ['科幻', '灾难', '冒险'],
    quality: '4K HDR',
    duration: '148分钟',
    region: '中国大陆',
    isHot: true,
    isNew: true,
    synopsis: '在《流浪地球3》中，随着地球逐渐远离太阳系，人类面临着来自深空的全新威胁。未知的外星信号被接收，地球发动机遭遇神秘力量干扰。联合政府紧急组建了一支由顶尖科学家和宇航员组成的探索队，前往信号源头探寻真相。在浩瀚宇宙中，他们发现了令人震惊的秘密——人类并非宇宙中唯一的智慧文明。面对前所未有的挑战，人类必须团结一心，在地球发动机的蓝色火焰中，书写属于全人类的新篇章。'
  },
  {
    id: 'movie-2',
    title: '长安三万里2',
    englishTitle: 'Chang An 2',
    category: 'movie',
    year: 2026,
    rating: 8.9,
    poster: 'https://readdy.ai/api/search-image?query=Animated%20movie%20poster%20in%20traditional%20Chinese%20ink%20painting%20style%2C%20ancient%20Tang%20dynasty%20palace%20with%20poets%20in%20flowing%20robes%2C%20golden%20warm%20tones%2C%20artistic%20watercolor%20texture%2C%20elegant%20classical%20composition&width=600&height=900&seq=movie-poster-2&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20cityscape%20with%20golden%20palace%20rooftops%20and%20cherry%20blossoms%2C%20warm%20sunset%20lighting%2C%20traditional%20ink%20painting%20aesthetic%2C%20cinematic%20widescreen%2C%20ethereal%20atmosphere&width=1600&height=700&seq=movie-bg-2&orientation=landscape',
    description: '盛唐气象万千，诗仙李白与好友高适再度踏上旅途，穿越千山万水，以诗会友，谱写了一段流传千古的文人传奇。本片延续第一部的唯美画风，讲述诗人们在中晚年的人生际遇。',
    director: '追光动画',
    cast: ['杨天翔', '凌振赫', '吴俊全'],
    genres: ['动画', '历史', '传记'],
    quality: '蓝光',
    duration: '168分钟',
    region: '中国大陆',
    isHot: true,
    isNew: false,
    synopsis: '安史之乱后，大唐由盛转衰。李白流放夜郎途中遇赦，写下"朝辞白帝彩云间"的千古绝唱。高适在边塞戍守，见证了国家的动荡与重生。两位挚友虽相隔千里，却以诗歌为纽带，互相慰藉。影片以壮丽的水墨画卷展现了盛唐诗人群体在乱世中的命运沉浮，以及他们留给后世的不朽诗篇。'
  },
  {
    id: 'movie-3',
    title: '狂飙',
    englishTitle: 'The Knockout',
    category: 'tv',
    year: 2023,
    rating: 9.1,
    poster: 'https://readdy.ai/api/search-image?query=Crime%20drama%20TV%20series%20poster%20with%20two%20men%20in%20dark%20suits%20facing%20each%20other%2C%20intense%20standoff%2C%20urban%20night%20backdrop%2C%20film%20noir%20lighting%2C%20dramatic%20shadows%2C%20Chinese%20crime%20thriller%20aesthetic&width=600&height=900&seq=movie-poster-3&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Dark%20urban%20cityscape%20at%20night%20with%20neon%20lights%20reflecting%20on%20wet%20streets%2C%20film%20noir%20cinematography%2C%20moody%20atmosphere%2C%20crime%20drama%20visual%20style%2C%20cinematic%20widescreen&width=1600&height=700&seq=movie-bg-3&orientation=landscape',
    description: '一部横跨二十年的扫黑除恶题材剧集，以一正一邪两个角色的命运交织为主线，展现了一场惊心动魄的正邪较量。',
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '张志坚'],
    genres: ['剧情', '犯罪', '悬疑'],
    quality: '4K',
    duration: '39集',
    region: '中国大陆',
    isHot: true,
    isNew: false,
    episodes: 39,
    synopsis: '故事从2000年开始，讲述了刑警安欣与鱼贩高启强之间长达二十年的较量。高启强从底层鱼贩一步步成为盘踞一方的黑恶势力头目，而安欣则始终坚守正义，在漫长的岁月中与黑恶势力展开殊死搏斗。这不仅是两个人的对决，更是一个时代扫黑除恶的缩影。'
  },
  {
    id: 'movie-4',
    title: '三体',
    englishTitle: 'Three-Body',
    category: 'tv',
    year: 2023,
    rating: 8.7,
    poster: 'https://readdy.ai/api/search-image?query=Sci-fi%20TV%20series%20poster%20with%20mysterious%20three%20suns%20in%20alien%20sky%2C%20astronomical%20phenomenon%2C%20cosmic%20scale%2C%20dark%20and%20mysterious%20aesthetic%2C%20minimalist%20design%2C%20Chinese%20sci-fi%20style&width=600&height=900&seq=movie-poster-4&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cosmic%20landscape%20with%20three%20stars%20in%20a%20chaotic%20orbit%2C%20alien%20planet%20surface%2C%20sci-fi%20atmosphere%2C%20deep%20space%20colors%2C%20mysterious%20and%20grand%2C%20cinematic%20widescreen&width=1600&height=700&seq=movie-bg-4&orientation=landscape',
    description: '根据刘慈欣同名科幻巨著改编，纳米科学家汪淼卷入神秘组织"科学边界"，揭开了地外文明"三体"世界的神秘面纱。',
    director: '杨磊',
    cast: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    genres: ['科幻', '悬疑', '剧情'],
    quality: '4K HDR',
    duration: '30集',
    region: '中国大陆',
    isHot: false,
    isNew: true,
    episodes: 30,
    synopsis: '2007年，地球基础科学出现了异常的扰动。纳米科学家汪淼被警官史强带到了联合作战中心，并潜入名为"科学边界"的组织协助调查。在调查过程中，汪淼接触到了一个名为"三体"的虚拟现实游戏，并由此发现了来自地外文明的威胁。面对前所未有的危机，人类必须团结起来，共同面对三体世界的挑战。'
  },
  {
    id: 'movie-5',
    title: '哪吒之魔童闹海',
    englishTitle: 'Nezha: The Devil is Born',
    category: 'anime',
    year: 2025,
    rating: 9.4,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20poster%20with%20mythological%20boy%20warrior%20with%20flaming%20wheels%20and%20red%20ribbon%2C%20dynamic%20action%20pose%2C%20fire%20and%20lightning%20effects%2C%20vibrant%20red%20and%20gold%20color%20scheme%2C%20epic%20fantasy%20style&width=600&height=900&seq=movie-poster-5&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20battle%20scene%20with%20fire%20and%20thunder%2C%20dragon%20in%20stormy%20sky%2C%20ancient%20Chinese%20architecture%2C%20dramatic%20red%20and%20gold%20lighting%2C%20cinematic%20animation%20style&width=1600&height=700&seq=movie-bg-5&orientation=landscape',
    description: '天劫之后，哪吒和敖丙的灵魂虽然保住了，但肉身很快会魂飞魄散。太乙真人打算用七色宝莲给二人重塑肉身，但过程中却遇到了重重困难。',
    director: '饺子',
    cast: ['吕艳婷', '瀚墨', '陈浩'],
    genres: ['动画', '奇幻', '动作'],
    quality: '4K',
    duration: '144分钟',
    region: '中国大陆',
    isHot: true,
    isNew: true,
    synopsis: '在经历了天劫之后，哪吒和敖丙的灵魂得以保存，但两人的肉身却面临消散的危机。太乙真人试图用七色宝莲为两人重塑肉身，然而在这个过程中，新的敌人出现了。面对更强大的对手，哪吒必须突破自我，不仅为了拯救自己，也为了保护陈塘关的百姓。'
  },
  {
    id: 'movie-6',
    title: '庆余年2',
    englishTitle: 'Joy of Life 2',
    category: 'tv',
    year: 2024,
    rating: 8.8,
    poster: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20drama%20poster%20with%20man%20in%20ancient%20royal%20robe%20holding%20sword%2C%20palace%20intrigue%20theme%2C%20dramatic%20lighting%2C%20gold%20and%20crimson%20color%20palette%2C%20epic%20costume%20drama%20style&width=600&height=900&seq=movie-poster-6&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20interior%20with%20golden%20dragon%20decorations%2C%20candlelit%20atmosphere%2C%20luxurious%20silk%20curtains%2C%20cinematic%20lighting%2C%20period%20drama%20aesthetic&width=1600&height=700&seq=movie-bg-6&orientation=landscape',
    description: '范闲在经历了上一季的生死考验后，回到京都继续他的传奇人生。朝堂之上暗流涌动，江湖之中风云变幻，一场更大的阴谋正在酝酿。',
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚'],
    genres: ['古装', '权谋', '剧情'],
    quality: '蓝光',
    duration: '36集',
    region: '中国大陆',
    isHot: false,
    isNew: false,
    episodes: 36,
    synopsis: '范闲从北齐归来后，发现京都局势已经发生了翻天覆地的变化。二皇子势力日益壮大，太子暗中筹谋，各方势力蠢蠢欲动。范闲在新一轮的权力斗争中游走于刀尖之上，同时也在追查母亲叶轻眉的真正死因。'
  },
  {
    id: 'movie-7',
    title: '封神第二部',
    englishTitle: 'Creation of the Gods II',
    category: 'movie',
    year: 2025,
    rating: 8.6,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20movie%20poster%20with%20warriors%20in%20ancient%20armor%2C%20mystical%20creatures%2C%20battle%20scene%2C%20dramatic%20epic%20composition%2C%20gold%20and%20bronze%20tones%2C%20cinematic%20style&width=600&height=900&seq=movie-poster-7&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20battlefield%20with%20thousands%20of%20soldiers%2C%20flying%20mythological%20beasts%2C%20stormy%20sky%2C%20dramatic%20lighting%2C%20cinematic%20grand%20scale%2C%20fantasy%20war%20scene&width=1600&height=700&seq=movie-bg-7&orientation=landscape',
    description: '殷商末年，纣王暴虐无道。姜子牙携封神榜下山，召集天下英雄，展开了一场惊天动地的封神之战。第二部聚焦西岐保卫战与魔家四将的登场。',
    director: '乌尔善',
    cast: ['费翔', '黄渤', '于适', '陈牧驰'],
    genres: ['奇幻', '战争', '古装'],
    quality: '4K IMAX',
    duration: '155分钟',
    region: '中国大陆',
    isHot: false,
    isNew: true,
    synopsis: '西岐城下，闻仲率领魔家四将兵临城下。姜子牙与姬发拼死守护，一场惊天动地的攻防战就此展开。与此同时，申公豹在暗中策划更大的阴谋，昆仑十二金仙纷纷现身，封神大战正式拉开帷幕。'
  },
  {
    id: 'movie-8',
    title: '咒术回战 第二季',
    englishTitle: 'Jujutsu Kaisen S2',
    category: 'anime',
    year: 2023,
    rating: 9.3,
    poster: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20with%20young%20sorcerer%20with%20white%20hair%20and%20blindfold%2C%20dynamic%20action%20pose%2C%20energy%20effects%2C%20dark%20supernatural%20aesthetic%2C%20vibrant%20anime%20art%20style&width=600&height=900&seq=movie-poster-8&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Anime%20style%20urban%20Tokyo%20at%20night%20with%20supernatural%20energy%20effects%2C%20dark%20purple%20and%20blue%20atmosphere%2C%20mystical%20battle%20scene%2C%20dynamic%20composition%2C%20Japanese%20animation%20aesthetic&width=1600&height=700&seq=movie-bg-8&orientation=landscape',
    description: '五条悟与夏油杰在高专时代的青春故事——怀玉篇，以及涉谷事变篇。最强咒术师的过去与现在，将在这一季中交织呈现。',
    director: '御所园翔太',
    cast: ['中村悠一', '樱井孝宏', '诹访部顺一'],
    genres: ['动画', '动作', '奇幻'],
    quality: '蓝光',
    duration: '23集',
    region: '日本',
    isHot: true,
    isNew: false,
    episodes: 23,
    synopsis: '第二季分为"怀玉·玉折"和"涉谷事变"两个篇章。前者讲述了五条悟和夏油杰在高专时代的往事，揭示了两人从挚友到敌人的转变过程。后者则是在现代时间线中，以涉谷为舞台展开的咒术师与咒灵之间的全面战争。'
  },
  {
    id: 'movie-9',
    title: '歌手2024',
    englishTitle: 'Singer 2024',
    category: 'variety',
    year: 2024,
    rating: 8.3,
    poster: 'https://readdy.ai/api/search-image?query=Music%20competition%20show%20poster%20with%20spotlight%20on%20stage%2C%20microphone%20in%20center%2C%20golden%20and%20purple%20lighting%2C%20grand%20concert%20atmosphere%2C%20elegant%20design&width=600&height=900&seq=movie-poster-9&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Grand%20concert%20stage%20with%20dramatic%20stage%20lighting%2C%20fog%20effects%2C%20empty%20arena%20with%20atmospheric%20lights%2C%20music%20show%20production%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=movie-bg-9&orientation=landscape',
    description: '华语乐坛顶级音乐竞技真人秀重磅回归！全新赛制，全新舞台，邀请华语乐坛实力唱将同台竞技，打造年度音乐盛宴。',
    director: '洪涛',
    cast: ['那英', '汪苏泷', 'Faouzia', 'Chante Moore'],
    genres: ['音乐', '综艺', '竞技'],
    quality: '超清',
    duration: '12期',
    region: '中国大陆',
    isHot: false,
    isNew: true,
    episodes: 12,
    synopsis: '《歌手2024》采用全新的全程直播形式，让观众实时感受顶级歌手的现场演唱魅力。节目邀请国内外实力唱将同台竞技，每期都有激烈的排名争夺。不仅有经典歌曲的重新演绎，更有原创作品的首发舞台。'
  },
  {
    id: 'movie-10',
    title: '奥本海默',
    englishTitle: 'Oppenheimer',
    category: 'movie',
    year: 2023,
    rating: 8.9,
    poster: 'https://readdy.ai/api/search-image?query=Biographical%20drama%20movie%20poster%20with%20man%20in%20fedora%20hat%20against%20nuclear%20explosion%20backdrop%2C%20black%20and%20white%20with%20orange%20fire%2C%20dramatic%20contrast%2C%20historical%20epic%20style&width=600&height=900&seq=movie-poster-10&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Massive%20mushroom%20cloud%20from%20nuclear%20explosion%20in%20desert%20landscape%2C%20dramatic%20orange%20and%20black%20sky%2C%20historical%20moment%2C%20cinematic%20epic%20scale%2C%20atmospheric&width=1600&height=700&seq=movie-bg-10&orientation=landscape',
    description: '克里斯托弗·诺兰执导的史诗传记片，讲述"原子弹之父"罗伯特·奥本海默在曼哈顿计划中的故事，以及他在核武器诞生后的道德困境。',
    director: '克里斯托弗·诺兰',
    cast: ['基里安·墨菲', '艾米莉·布朗特', '马特·达蒙'],
    genres: ['传记', '历史', '剧情'],
    quality: '4K IMAX',
    duration: '180分钟',
    region: '美国',
    isHot: false,
    isNew: false,
    synopsis: '影片聚焦于理论物理学家J·罗伯特·奥本海默在第二次世界大战期间领导曼哈顿计划开发第一批核武器的经历。影片通过两条时间线展开：一条是奥本海默在洛斯阿拉莫斯的科研历程，另一条是战后他面临的安全听证会。诺兰以独特的叙事手法，深入探讨了科学、道德与权力之间的复杂关系。'
  },
  {
    id: 'movie-11',
    title: '鬼灭之刃 柱训练篇',
    englishTitle: 'Demon Slayer: Hashira Training',
    category: 'anime',
    year: 2024,
    rating: 8.7,
    poster: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20with%20young%20swordsman%20with%20green%20checkered%20pattern%20cloak%2C%20water%20breathing%20effects%2C%20demon%20slayer%20aesthetic%2C%20dynamic%20composition%2C%20vibrant%20color%20scheme&width=600&height=900&seq=movie-poster-11&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Ancient%20Japanese%20village%20at%20night%20with%20cherry%20blossoms%20and%20lanterns%2C%20moonlit%20atmosphere%2C%20traditional%20architecture%2C%20anime%20aesthetic%2C%20cinematic%20widescreen&width=1600&height=700&seq=movie-bg-11&orientation=landscape',
    description: '为了迎接与鬼舞辻无惨的最终决战，炭治郎和伙伴们接受九柱的严格训练。每一位柱都将倾囊相授，帮助年轻剑士们突破极限。',
    director: '外崎春雄',
    cast: ['花江夏树', '鬼头明里', '下野纮'],
    genres: ['动画', '动作', '奇幻'],
    quality: '蓝光',
    duration: '8集',
    region: '日本',
    isHot: false,
    isNew: true,
    episodes: 8,
    synopsis: '在无限城决战前夕，鬼杀队当主产屋敷耀哉决定让所有队员接受九柱的集训。水柱富冈义勇、炎柱炼狱杏寿郎等人的继任者们，以及恋柱甘露寺蜜璃、蛇柱伊黑小芭内等柱级剑士，各自以自己的方式训练年轻队员们。这是一段关于成长、传承与决心的故事。'
  },
  {
    id: 'movie-12',
    title: '奔跑吧 第八季',
    englishTitle: 'Keep Running S8',
    category: 'variety',
    year: 2024,
    rating: 7.9,
    poster: 'https://readdy.ai/api/search-image?query=Variety%20show%20poster%20with%20celebrity%20cast%20running%20in%20colorful%20outfits%2C%20playful%20energy%2C%20bright%20and%20cheerful%20design%2C%20outdoor%20adventure%20theme%2C%20Chinese%20entertainment%20style&width=600&height=900&seq=movie-poster-12&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20natural%20landscape%20with%20rolling%20hills%20and%20clear%20sky%2C%20outdoor%20adventure%20setting%2C%20bright%20sunlight%2C%20cinematic%20widescreen%2C%20positive%20vibrant%20atmosphere&width=1600&height=700&seq=movie-bg-12&orientation=landscape',
    description: '国内最长寿的户外竞技真人秀再度启程！兄弟团携手新成员，在全国各地展开趣味十足的挑战与冒险，为观众带来无限欢乐。',
    director: '姚译添',
    cast: ['李晨', '郑恺', '沙溢', '白鹿', '周深'],
    genres: ['综艺', '户外', '竞技'],
    quality: '超清',
    duration: '12期',
    region: '中国大陆',
    isHot: false,
    isNew: false,
    episodes: 12,
    synopsis: '第八季延续了奔跑吧系列经典的户外竞技模式，兄弟团在全新的城市和场景中完成各种趣味任务。本季加入了更多文化探索元素，让观众在欢笑中感受不同城市的人文魅力。'
  }
];

export const hotMovies = movies.filter(m => m.isHot);
export const newMovies = movies.filter(m => m.isNew);
export const moviesByCategory = (category: string) => movies.filter(m => m.category === category);
export const getMovieById = (id: string) => movies.find(m => m.id === id);